<div *ngFor="let i of rerenderProps">
  <div class="activity-body">
    <!-- sent (inactive) e-Mail Header -->
    <div *ngIf="isInactivityState()" class="sent-email-caption">{{ 'email_activity_Caption' | xsI18n }}</div>
    <div *ngIf="isInactivityState()" class="sent-email-header">
      <div class="sent-email-information">
        <div
          class="sent-email-sender"
          sa-ellipsis
          [fullText]="'email_Sent_By_Caption' | xsI18n : activityCtrl.creationUser"
        ></div>
        <div class="existing-uploaded-pipe"><span class="subtext-gray">|</span></div>
        <div class="sent-email-creation-date">
          <xs-updating-time hidespan="true" [time]="activity.creationDate"></xs-updating-time>
        </div>
      </div>

      <div class="to-list" [hidden]="!showRecipients()">
        <xs-collapsible-user-list
          [userInfoList]="recipientsUserInfos"
          [label]="'email_Sent_To_Caption' | xsI18n"
        ></xs-collapsible-user-list>
      </div>

      <div class="cc-list" [hidden]="!showCCRecipients()">
        <xs-collapsible-user-list
          [userInfoList]="recipientsCCUserInfos"
          [label]="'email_Sent_CC_Caption' | xsI18n"
        ></xs-collapsible-user-list>
      </div>
    </div>

    <!-- compose (active) e-Mail Header -->
    <div *ngIf="!isInactivityState()" class="compose-email-header">
      <div class="compose-email-header-group">
        <div class="compose-email-header-group-caption">
          <div class="compose-email-header-caption">{{ 'email_NewEmail_Caption' | xsI18n }}</div>
        </div>
        <div class="compose-email-header-group-button">
          <div class="local-attachment-menu-wrapper">
            <button
              *ngIf="ticketPageService.ticketContextService.canAddAttachment()"
              class="attach-button"
              type="button"
              id="local-attachment-btn"
              [disabled]="isEmailContentUpdating()"
              (click)="localAttachmentMenuToggle($event)"
            >
              <div class="circle-button">
                <span class="hd-icon hd-icon-attachment icon-md no-gutter attachment-icon"></span>
              </div>
            </button>
            <xs-popup-menu
              class="attachment-popup"
              *ngIf="!isInactivityState()"
              popupAlign="right"
              [disableDropup]="false"
              [(isOpen)]="toggleAttachmentPopup"
              targetSelector=".local-attachment-menu-wrapper"
            >
              <xs-attachment-menu
                [attachmentList]="getAttachments()"
                (onSelect)="onSelectAttachment($event)"
              >
              </xs-attachment-menu>
            </xs-popup-menu>
          </div>
        </div>
      </div>
      <div class="compose-email-header-recipients">
        <xs-recipients-list
          recipientType="to"
          [recipientTypeCaption]="'email_To_Prefix' | xsI18n"
          [(recipientsList)]="recipientsUserInfos"
          (onAddRecipient)="addRecipient($event)"
          (onRemoveRecipient)="removeEmailRecipient($event)"
          (onError)="setError(error)"
          [isDisabled]="!isNew()"
          [recipientsBeingResolved]="isLoading('to')"
        >
        </xs-recipients-list>
      </div>
      <div class="compose-email-header-recipients">
        <xs-recipients-list
          recipientType="cc"
          [recipientTypeCaption]="'email_CC_Prefix' | xsI18n"
          [(recipientsList)]="recipientsCCUserInfos"
          (onAddRecipient)="addRecipient($event)"
          (onRemoveRecipient)="removeEmailRecipient($event)"
          (onError)="setError(error)"
          [isDisabled]="!isNew()"
          [recipientsBeingResolved]="isLoading('cc')"
        >
        </xs-recipients-list>
      </div>
    </div>

    <!--e-Mail content textarea, resused for both active and inactive e-mails -->
    <div class="outbound-email-body">
      <div class="rich-text-wrapper">
        <quill-editor
          class="outbound-email-quill"
          *ngIf="isNew()"
          (onContentChanged)="setBodyDelta($event)"
          [(ngModel)]="body"
          (onEditorCreated)="setupQuill($event)"
          [modules]="quillModules"
          [placeholder]="'email_body_placeholder_text' | xsI18n"
        >
        </quill-editor>

        <quill-view *ngIf="!isNew()" [content]="bodyDelta" format="object"></quill-view>

        <xs-popup-menu
          *ngIf="!isInactivityState()"
          class="inline-image-popup"
          [(isOpen)]="toggleInlinePopup"
          targetSelector=".outbound-email-quill .ql-image"
          popupAlign="auto right"
          popupTop="0"
        >
          <xs-attachment-menu
            [attachmentList]="getImageAttachments()"
            (onSelect)="onSelectInlineAttachment($event)"
            [fileSelectionType]="getImageExtensionList()"
            [menuTitle]="'inlineImageMenu_title' | xsI18n"
          >
          </xs-attachment-menu>
        </xs-popup-menu>
      </div>
    </div>

    <!-- Email attachments -->
    <xs-email-attachment
      (onDelete)="removeAttachmentToSend($event)"
      [attachments]="getEmailAttachments()"
      [showClose]="isNew()"
      [isDisabled]="!isNew()"
    >
    </xs-email-attachment>

    <!-- Error-Message/Attachment-Upload-Progressbar & Cancel/Send Email Buttons -->
    <div class="compose-email-footer" *ngIf="isNew()">
      <div class="footer-upload-progress-bar" *ngIf="isUploading">
        <!-- XTODO: replace with mat-progress bar -->
        <!-- <uib-progressbar max="100" animate="false" value="progress"></uib-progressbar>
        -->
        <progressbar max="100" animate="false" value="progress"></progressbar>
      </div>

      <div class="footer-error-message">
        <span class="xsight-body3 footer-error-message-caption" *ngIf="error">
          <div sa-ellipsis [fullText]="'email_Error' | xsI18n : error" class="footer-error-message"></div>
        </span>
        <span class="xsight-body3 footer-error-message-caption" *ngIf="duplicateExists">{{
          'duplicate_Attachment_Warning' | xsI18n
        }}</span>
      </div>

      <div class="footer-saving-draft-message" *ngIf="isDraftSaving()">
        <div>{{ 'email_Saving_Draft' | xsI18n }}</div>
      </div>

      <div class="footer-button-section">
        <div class="footer-button">
          <button class="xs-btn btn-outline btn-space" type="button" (click)="cancel()" [disabled]="isSaving()">
            <span class="footer-button-caption">{{ 'xs_cancel_label_short' | xsI18n }}</span>
          </button>
        </div>

        <div class="footer-button">
          <button type="button" class="xs-btn btn-primary" (click)="send()" [disabled]="isEmailContentUpdating()">
            <span class="footer-button-caption">{{ 'email_Send_Caption' | xsI18n }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
